import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '../utils/cn'
// ATTENTION! We use outline variant for not default buttons. NOT a secondary
const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-md text-description transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-auto disabled:opacity-50 disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        default:
          // 'bg-primary text-primary-foreground rounded-full border-primary  leading-5	 border hover:bg-buttonDefault-hover transition-all',
          'bg-primary text-primary-foreground rounded-full border-primary  leading-5	 border  hover:bg-buttonDefault-hover  disabled:hover:bg-primary   disabled:hover:text-primary-foreground  transition-all',
        destructive: 'rounded-full bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
        outline:
          'rounded-full border-primary  leading-5	 border bg-background shadow-sm hover:bg-primary hover:text-buttonOutline transition-all',
        miniOutline:
          'rounded-none border-primary  leading-4	 border bg-background shadow-sm hover:bg-primary hover:text-buttonOutline transition-all',
        secondary: 'bg-primary-foreground text-primary rounded-full leading-5 hover:bg-secondary/80',
        ghost: 'hover:opacity-50 transition-all duration-300 text-primary spacing-0 p-0 text-description',
        // ghost: 'hover:bg-accent hover:text-accent-foreground text-primary',
        // ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
        // icon: 'rounded-full border-primary border transition-all',
        icon: 'rounded-full border-primary border hover:bg-primary hover:text-buttonOutline transition-all text-primary',
      },
      size: {
        default: 'px-4 py-3',
        empty: '',
        // default: 'h-9 px-4 py-2',
        sm: 'h-8 rounded-md px-3 text-xs',
        md: 'h-8 rounded-md px-3',
        lg: 'h-10 rounded-md px-8',
        icon: 'p-3',
        textIcon: 'px-4 py-3',
      },
      weight: {
        default: 'font-light', // 300
        medium: 'font-medium', // 500
        // default: 'h-9 px-4 py-2',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      weight: 'default',
    },
  },
)
// class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-description transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2"
export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button'
    return (
      <Comp
        // className={cn('px-4 py-3 font-light')}
        className={cn(buttonVariants({ variant, size, className }), '')}
        ref={ref}
        {...props}
      />
    )
  },
)
Button.displayName = 'Button'

export { Button, buttonVariants }
// import * as React from 'react'
// import { Slot } from '@radix-ui/react-slot'
// import { cva, type VariantProps } from 'class-variance-authority'

// import { cn } from '../utils/cn'

// const buttonVariants = cva(
//   'inline-flex items-center justify-center whitespace-nowrap rounded-md text-description transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
//   {
//     variants: {
//       variant: {
//         // default: 'bg-primary text-primary-foreground shadow hover:bg-primary/90',
//         default: 'bg-primary text-primary-foreground ',
//         destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
//         outline: 'border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground',
//         secondary: 'bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80',
//         ghost: 'hover:opacity-50 hover:transition-opacity text-primary spacing-0 p-0 text-description',
//         // ghost: 'hover:bg-accent hover:text-accent-foreground text-primary',
//         // ghost: 'hover:bg-accent hover:text-accent-foreground',
//         link: 'text-primary underline-offset-4 hover:underline',
//       },
//       size: {
//         default: 'h-9 px-4 py-2',
//         empty: '',
//         // default: 'h-9 px-4 py-2',
//         sm: 'h-8 rounded-md px-3 text-xs',
//         lg: 'h-10 rounded-md px-8',
//         icon: 'h-9 w-9',
//       },
//       weight: {
//         default: 'font-light',
//         medium: 'font-medium',
//         // default: 'h-9 px-4 py-2',
//       },
//     },
//     defaultVariants: {
//       variant: 'default',
//       size: 'default',
//     },
//   },
// )

// export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
//   asChild?: boolean
// }

// const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({ className, variant, size, asChild = false, ...props }, ref) => {
//   const Comp = asChild ? Slot : 'button'
//   return (
//     <Comp
//       className={cn(buttonVariants({ variant, size, className }))}
//       ref={ref}
//       {...props}
//     />
//   )
// })
// Button.displayName = 'Button'

// export { Button, buttonVariants }
